import dayjs from "dayjs";

// F-1: a report must never send FromDate/ToDate as "Invalid Date".
// The pages clear the to-date when the from-date changes, so the request is
// skipped until both dates are set and valid.
export const isValidDateRange = (fromDate, toDate) =>
  !!fromDate &&
  !!toDate &&
  dayjs(fromDate).isValid() &&
  dayjs(toDate).isValid();
